import locale from './locale';
import authentication from './authentication';
import mainLayouts from './main-layouts';
import appState from './appState';

export const appReducers = {
  locale,
  authentication,
  mainLayouts,
  appState,
};
